import React, { useEffect } from "react";
import { Typography, useMediaQuery } from "@mui/material";

// Components
import { ScoreboardFullDetailsTable } from "./ScoreboardFullDetailsTable";

// Utils and Types
import { Cadet } from "../shared/types/scoreboard.types";
import theme from "../config/theme/theme";

// Styles
import "../App.css";

interface ScoreboardProps {
  data: Cadet[];
}

export const Scoreboard: React.FC<ScoreboardProps> = ({ data }) => {
  // const [infoOpen, setInfoOpen] = useState(true);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ width: isMobile ? "95vw" : "80%", margin: "auto", paddingTop: "10px" }}>
      <Typography
        variant="h3"
        sx={{ fontFamily: "Georgia", marginTop: "20px", marginBottom: "20px", fontSize: "clamp(1.7rem, 4vw, 4rem)" }}
        gutterBottom>
        Current Leaderboard
      </Typography>

      <ScoreboardFullDetailsTable data={data} />
    </div>
  );
};
